(function (angular) {
	'use strict';

	angular
		.module('futureEarningsChartModule')
		.factory('futureEarningsFactory', [
			'Big',
			'moment',
			futureEarningsFunction
		]);

	function futureEarningsFunction(
		Big,
		moment) {
		
		var factory = {
			getProjectedAccountValue: getProjectedAccountValue,
			getReinvestmentDataWithCompoundingInterest: getReinvestmentDataWithCompoundingInterest,
			getDataWithSimpleInterest: getDataWithSimpleInterest,
			getDataWithAutoInvest: getDataWithAutoInvest
		};

		return factory;
		
		function getProjectedAccountValue(principal, interest, numberOfQuarters) {
			var series = getReinvestmentDataWithCompoundingInterest(principal, interest, numberOfQuarters);
			return series[series.length-1].y;
		}

		function getReinvestmentDataWithCompoundingInterest(principal, interest, numberOfQuarters){
			var data = [];
			var currentPrincipal = new Big(principal);
			interest = new Big(interest).plus(1);

			for(var i = 0; i <= numberOfQuarters; i++) {
				var timestamp = moment().add(i*3, 'months').valueOf();

				var point = {
					x: timestamp,
					y: Number(currentPrincipal)
				};

				if (i === numberOfQuarters) {
					point.marker = {
						enabled: true,
						symbol: "circle"
					};
				} else {
					point.marker = {
						states: {
							hover: {
								enabled: false
							}
						}
					};
				}

				data.push(point);

				currentPrincipal = currentPrincipal.times(interest);
			}

			return data;
		}
		
		function getDataWithSimpleInterest(principal, interest, numberOfQuarters){
			var data = [];

			for(var i = 0; i <= numberOfQuarters; i++) {
				var currentPrincipal = (principal * i * interest) + principal;
				var timestamp = moment().add(i*3, 'months').valueOf();

				var point = {
					x: timestamp,
					y: currentPrincipal
				};

				if (i === numberOfQuarters) {
					point.marker = {
						enabled: true,
						symbol: 'circle'
					};
				} else {
					point.marker = {
						states: {
							hover: {
								enabled: false
							}
						}
					};
				}

				data.push(point);
			}

			return data;
		}

		function getDataWithAutoInvest(principal, interest, numberOfQuarters, frequency, amount) {
			var data = [];
			var currentPrincipal = principal;
			var monthlyInterest = interest / 3;
			var quarterlyContributions = frequency === 6 ? 3 : 6;

			for(var i = 0; i <= numberOfQuarters; i++) {
				var timestamp = moment().add(i*3, 'months').valueOf();
				var point = {
					x: timestamp,
					y: currentPrincipal
				};

				if (i === numberOfQuarters) {
					point.marker = {
						enabled: true,
						symbol: 'circle'
					};
				}

				data.push(point);
				currentPrincipal = currentPrincipal * (1 + interest) + (parseInt(amount) * quarterlyContributions) + (amount * frequency * monthlyInterest);
			}

			return data;
		}
	}
})(window.angular);